const React = require('react');
const PropTypes = require('prop-types');
const { Cell, PieChart, Pie, ResponsiveContainer } = require('recharts');
const rotateColor = require('utilities/rotateColor');
const DonutActivePortion = require('./DonutActivePortion');

const DonutChart = ({
    activeIndex,
    colors,
    data,
    dataKey,
    height,
    titles,
    width,
    textWidth,
}) => (
    <ResponsiveContainer height={height} width={width}>
        <PieChart className="donut-chart" height={height}>
            <Pie
                activeIndex={activeIndex || 0}
                activeShape={props => (
                    <DonutActivePortion
                        {...props}
                        titles={titles}
                        textWidth={textWidth}
                    />
                )}
                cy={height / 2}
                data={data}
                dataKey={dataKey}
                innerRadius={80}
                isAnimationActive
                outerRadius={100}
            >
                {data &&
                    data.map((entry, i) => (
                        <Cell fill={rotateColor(colors, i)} key={i} />
                    ))}
            </Pie>
        </PieChart>
    </ResponsiveContainer>
);

DonutChart.defaultProps = {
    colors: [],
    dataKey: 'value',
    height: 400,
    width: 400,
    textWidth: null,
};

DonutChart.propTypes = {
    activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    dataKey: PropTypes.string,
    height: PropTypes.number,
    titles: PropTypes.object,
    textWidth: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

module.exports = DonutChart;
